<div class="add-container">
    <h1 class="add-title">Adaugă instituție</h1>

    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Denumire instituție</mat-label>
                <input type="text" matInput formControlName="denumire_institutie" />
            </mat-form-field>
            <mat-error
                *ngIf="!form.controls['denumire_institutie'].valid && form.controls['denumire_institutie'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Email instituție</mat-label>
                <input type="email" matInput formControlName="email_institutie" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['email_institutie'].valid && form.controls['email_institutie'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Locație</mat-label>
                <input type="text" matInput formControlName="locatie" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['locatie'].valid && form.controls['locatie'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Telefon</mat-label>
                <input type="text" matInput formControlName="telefon" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['telefon'].valid && form.controls['telefon'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>